import React from 'react';
import { Link } from 'react-router-dom';

const Main = () => {
  return (
    <div>
      <ul>
        <li>
          <Link to='/slide'>
            Slide Test
          </Link>
        </li>
        <li>
          <Link to='/video'>
            Video Test
          </Link>
        </li>
        <li>
          <Link to='/introduction1'>
            시작
          </Link>
        </li>
        <li>
          <Link to='/presentation'>
            프리젠테이션
          </Link>
        </li>
      </ul>
    </div>
  )
}

export default Main;